<template>
  <div class="field">
    <div v-for="(option, index) in options" :key="index">
      <b-radio
        :value="value"
        type="is-teal"
        size="is-small"
        :native-value="option.value"
        @input="handleInput"
      >
        {{ option.label }}
      </b-radio>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: "SortButtons",
  data() {
    return {
      optionVal: "",
    };
  },
  props: {
    options: {},
    value: String,
    typeOfSearch: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    handleInput(val) {
      // console.log('sort', val);
      this.optionVal = val;
      this.$emit("input", this.optionVal);
    },
  },
  mounted() {
    // console.log('this.typeOfSearch', this.typeOfSearch);
  },
};
</script>

<style lang="scss" scoped></style>
